import { serviceHandler } from '../service-executor';

const ORDER_URL = '/api/otr/orders';

export const getDispatchOrders = (appointment, start, end, from, pagesize) => {
  const URL = `${ORDER_URL}/appointment/${appointment}?start=${start}&end=${end}&size=${pagesize}&from=${from}`;
  return serviceHandler(URL, 'GET');
};

export const getLoads = (start, end, from, pagesize) => {
  const URL = `${ORDER_URL}/loads?start=${start}&end=${end}&size=${pagesize}&from=${from}`;
  return serviceHandler(URL, 'GET');
};

export const getOrderById = orderId => {
  const URL = `${ORDER_URL}/${orderId}`;
  return serviceHandler(URL, 'GET');
};

export const save = order => {
  const URL = `${ORDER_URL}`;
  return serviceHandler(URL, 'POST', order);
};

export const update = order => {
  const URL = `${ORDER_URL}/${order.id}`;
  return serviceHandler(URL, 'PUT', order);
};

export const deleteOrder = orderId => {
  const URL = `${ORDER_URL}/${orderId}`;
  return serviceHandler(URL, 'DELETE');
};

export const search = params => {
  const URL = `${ORDER_URL}/search`;
  return serviceHandler(URL, 'POST', params);
};

export const setNextStatusForOrder = (orderId, leg, timestamp, action, address) => {
  let URL = `${ORDER_URL}/${orderId}/legs/${leg.id}/status?action=${action}&appointment=${timestamp}`;  
  return address ? serviceHandler(URL, 'POST', address): serviceHandler(URL, 'POST');
};

// export const updateOrderRate = (orderId, rate) => {
//   const URL = `${ORDER_URL}/${orderId}/rate/update`;
//   return serviceHandler(URL, 'POST', rate);
// };

export const updateOrderLocation = (orderId, legId, locationId, orderLocation, locationType) => {
  if(locationType === 'Origin') {
    return serviceHandler(`${ORDER_URL}/${orderId}/legs/${legId}/origins/${locationId}/update`, 'PUT', orderLocation);
  } else {
    return serviceHandler(`${ORDER_URL}/${orderId}/legs/${legId}/destinations/${locationId}/update`, 'PUT', orderLocation);
  }  
};

export const updateOrderEquipment = (orderId, truckId, truck) => {
  const URL = `${ORDER_URL}/${orderId}/equipments/${truckId}/update`;
  return serviceHandler(URL, 'PUT', truck);
};

export const updateOrderSummary = (orderId, summary) => {
  const URL = `${ORDER_URL}/${orderId}/summary/update`;
  return serviceHandler(URL, 'PUT', summary);
};

export const getOrderTimingStats = (orderId) => {
  const URL = `${ORDER_URL}/${orderId}/stats`;
  return serviceHandler(URL, 'GET');
};

export const getInvoiceByOrderId = (orderId) => {
  const URL = `${ORDER_URL}/${orderId}/invoice`;
  return serviceHandler(URL, 'GET');
};

export const getFilesByOrderId = (orderId) => {
  return serviceHandler(`/api/document/list/${orderId}?isOTR=true`, 'GET');
}

export const uploadFileAttachment = data => {
  const URL = `/api/document/upload`;
  return serviceHandler(URL, 'PUT', data);
};

export const deleteFileAttachment = (orderId, uuid) => {
  const URL = `/api/document/delete/${orderId}/${uuid}`;
  return serviceHandler(URL, 'DELETE');
};

export const downloadFileAttachment = (uuid) => {
  const URL = `/api/document/download/${uuid}`;
  return serviceHandler(URL, 'GET');
};